module.exports = __webpack_public_path__ + "media/images/logo/Logo-aa5576756a1eb120c4ec5f5159a15417.svg";